export enum EnumVariacoesDadosEspecificos {
  Sortimento = 0,
  Grade = 1,
  Nenhum = 2,
}
